module.exports = __webpack_public_path__ + "static/img/success5.311c6776.png";